export default __webpack_public_path__ + "static/media/iceshackle.750fec3f.png";